var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3F2FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 22,
    fill: "#BBDEFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1545_24170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8387 27.2226V27.0448C36.8008 25.5398 36.169 24.1109 35.0813 23.0701C33.9936 22.0292 32.5383 21.4609 31.0331 21.4893C29.9121 21.4801 28.8123 21.7951 27.8661 22.3964C26.9199 22.9976 26.1677 23.8594 25.6998 24.8782C24.3825 25.0251 23.1649 25.6505 22.278 26.6356C21.3912 27.6208 20.8968 28.8971 20.8887 30.2226C20.8901 30.9249 21.03 31.6201 21.3003 32.2683C21.5706 32.9165 21.9659 33.5051 22.4638 34.0004C22.9617 34.4958 23.5524 34.8881 24.202 35.155C24.8516 35.4219 25.5475 35.5582 26.2498 35.556H28.3331V34.4448H26.2498C25.176 34.3867 24.1641 33.9237 23.4182 33.1491C22.6722 32.3745 22.2476 31.3459 22.23 30.2707C22.2124 29.1954 22.6031 28.1535 23.3232 27.3549C24.0434 26.5563 25.0396 26.0603 26.1109 25.9671H26.4831L26.6109 25.6171C26.9555 24.7221 27.5664 23.9546 28.3613 23.418C29.1561 22.8815 30.0965 22.6019 31.0553 22.6171C32.2659 22.5886 33.4387 23.0398 34.318 23.8723C35.1974 24.7049 35.712 25.8512 35.7498 27.0615C35.7574 27.2096 35.7574 27.3579 35.7498 27.506L35.7053 27.906L36.0664 28.0726C36.7649 28.3873 37.3336 28.9329 37.677 29.6177C38.0203 30.3024 38.1174 31.0846 37.9518 31.8325C37.7861 32.5804 37.368 33.2484 36.7676 33.7242C36.1672 34.2 35.4213 34.4545 34.6553 34.4448H31.6664V35.556H34.6553C35.6434 35.563 36.6056 35.2407 37.39 34.6398C38.1743 34.039 38.7361 33.1939 38.9866 32.2381C39.237 31.2823 39.1618 30.2703 38.7728 29.362C38.3838 28.4537 37.7033 27.7009 36.8387 27.2226Z",
    fill: "url(#paint0_linear_1545_24170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.379 32.1379C32.4898 32.1397 32.5986 32.1083 32.6914 32.0477C32.7843 31.9871 32.8568 31.9002 32.8999 31.798C32.9429 31.6959 32.9543 31.5832 32.9328 31.4745C32.9113 31.3658 32.8577 31.266 32.779 31.1879L30.0012 28.4102L27.2234 31.1879C27.1324 31.2942 27.0849 31.4309 27.0903 31.5707C27.0957 31.7106 27.1536 31.8432 27.2526 31.9421C27.3515 32.0411 27.4841 32.099 27.624 32.1044C27.7638 32.1098 27.9005 32.0623 28.0068 31.9713L29.4457 30.5546V37.3602C29.4457 37.5075 29.5042 37.6488 29.6084 37.753C29.7126 37.8572 29.8539 37.9157 30.0012 37.9157C30.1486 37.9157 30.2899 37.8572 30.394 37.753C30.4982 37.6488 30.5568 37.5075 30.5568 37.3602V30.5546L31.9845 31.9824C32.0903 32.0843 32.2321 32.1403 32.379 32.1379Z",
    fill: "url(#paint1_linear_1545_24170)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_24170",
    x1: 30.0102,
    y1: 21.4883,
    x2: 30.0102,
    y2: 35.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E9AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1545_24170",
    x1: 30.0166,
    y1: 28.4102,
    x2: 30.0166,
    y2: 37.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E9AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1545_24170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/UploadFileIcon.b6b3b324b300a8c2b0f062d79a61ab87.svg";
export { ForwardRef as ReactComponent };